import { render, staticRenderFns } from "./BookingInfoCard.vue?vue&type=template&id=d40c437a&scoped=true&"
import script from "./BookingInfoCard.vue?vue&type=script&lang=ts&"
export * from "./BookingInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookingInfoCard.vue?vue&type=style&index=0&id=d40c437a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40c437a",
  null
  
)

export default component.exports